import deployment from '../../../PublisherPortal/App_Data/deployment';
import ServiceDiscovery from 'fb-utils/serviceDiscovery';
const registry = 'https://registry-tc.' + (((env) => {
    switch (env) {
        case 'Release':return 'is';
        case 'Test':return 'test';
        case 'TestAlt':return 'test-alt';
        case 'Development':return 'dev';
    }
    return null;
})(deployment.ENVIRONMENT)) + '.flippingbook.com/api/';
export { registry };
const sd = new ServiceDiscovery(registry, deployment.ENVIRONMENT, deployment.ENVIRONMENT, {});

// sd.PatchAuthority('https://cld.mobi', 'http://localhost:37873');

export default sd;
